define('lq/design/editors/dropCache',[
    'underscore',
    'lq/cache'
], function (_, Cache) {
	'use strict';

    // TODO: handle name changes

	function DropCache() {
	    this.clear();
    };

	DropCache.prototype.clear = function () {
	    this.idCache = new Cache();
	    this.dropCachesByType = new Cache();
	    this.all = [];
	};

	DropCache.prototype.initialize = function (rootDrop) {
        rootDrop.withOnChildDropAttached(this.addDrop.bind(this));
        rootDrop.withOnChildDropDetached(this.removeDrop.bind(this));
        rootDrop.withOnChildDropCreated(this.addDrop.bind(this));
        rootDrop.withOnChildDropDeleted(this.removeDrop.bind(this));
	};

    DropCache.prototype.addDrop = function (drop) {
        if (!drop.data.id) return;

	    this.idCache.set(drop.data.id, drop);
	    this.getCacheForType(drop.data.type)
            .set(drop.data.id, drop);

		for (var i = 0; i < this.all.length; i++) {
			var obj = this.all[i];
			if (drop.data.id === obj.data.id && drop.data.id !== undefined && obj.data.id !== undefined) {
				this.all.splice(i, 1);
				break;
			}
		}
	    this.all.push(drop);

	    var self = this;
	    _.each(drop.pool, function(child) {
	        self.addDrop(child);
	    });
	};

	DropCache.prototype.removeDrop = function (drop) {
	    this.idCache.remove(drop.data.id);
	    this.getCacheForType(drop.data.type)
            .remove(drop.data.id);

	    var index = this.all.indexOf(drop);
		if (index > -1) {
			this.all.splice(index, 1);

			var self = this;
			_.each(drop.pool, function (child) {
				self.removeDrop(child);
			});
		}
	};

	DropCache.prototype.getDropById = function (id) {
		return this.idCache.get(id);
	};

	DropCache.prototype.getDropByName = function (name) {
	    return _.find(this.all, function(drop) {
	        return drop.data.name === name;
	    });
	};

	DropCache.prototype.getCacheForType = function (type) {
	    var typeCache = this.dropCachesByType.get(type);
	    if (!typeCache) {
	        typeCache = new Cache();
	        this.dropCachesByType.set(type, typeCache);
	    }
	    return typeCache;
	};

	DropCache.prototype.getDropsByType = function (type) {
	    return this.getCacheForType(type).values();
    };

	DropCache.prototype.getConditions = function () {
	    return this.getDropsByType('Condition');
	};

	DropCache.prototype.getDropsThatCanReceiveData = function () {
	    return this.findDropsWithAName(function (drop) {
	        return drop.designData.receivesData;
	    });
	};

	DropCache.prototype.getNamesOfDropsThatCanReceiveData = function () {
	    var drops = this.getDropsThatCanReceiveData();
	    return this.getNamesOfDrops(drops);
	};

	DropCache.prototype.getDropsThatCanProvideData = function () {
	    return this.findDropsWithAName(function (drop) {
	        return drop.designData.providesData;
	    });
    };

	DropCache.prototype.getNamesOfDropsThatCanProvideData = function () {
	    var drops = this.getDropsThatCanProvideData();
	    return this.getNamesOfDrops(drops);
    };

    DropCache.prototype.getNamesOfDropsThatHaveMethods = function () {
        var drops = this.findDropsWithAName(function (drop) {
            return drop.designData.methods && drop.designData.methods.length > 0;
        });
        return this.getNamesOfDrops(drops);
    };

	DropCache.prototype.getVisualDrops = function () {
	    return this.findDropsWithAName(function (drop) {
	        return drop.designData.isSystemDrop !== true;
	    });
	};

	DropCache.prototype.getNameAndIdsOfDrops = function (filter) {
		return _.chain(this.all)
			.filter(function (drop) {
				return !!drop.data.name && filter(drop);
			})
			.map(function(drop) {
				return { key: drop.data.id, value: drop.data.name };
			})
			.sortBy(function(pair) {
				return pair.value.toLowerCase();
			})
			.value();
	};

	DropCache.prototype.getNamesOfDrops = function (drops) {
	    return _.chain(drops)
	        .map(function(drop) {
	            return drop.data.name;
	        })
            .compact()
	        .sortBy(function(n) {
	            return n.toLowerCase();
	        })
	        .value();
	};

	DropCache.prototype.getNamesOfDropsByType = function (type) {
	    return this.getNamesOfDrops(this.getDropsByType(type));
    };

    DropCache.prototype.getNamesOfDropsByTypes = function (types) {
        return _.chain(types)
            .map(this.getNamesOfDropsByType.bind(this))
            .flatten()
            .value();
    };

	DropCache.prototype.getNamesOfDropsFiltered = function (filter) {
		return this.getNamesOfDrops(this.findDropsWithAName(filter));
	};

	DropCache.prototype.findDropsWithAName = function (filter) {
	    return _.chain(this.all)
	        .reject(function(drop) {
	            return !drop.data.name;
	        })
	        .filter(filter)
	        .value();
    };

    DropCache.prototype.isDropNameUnique = function (newName) {
        if (!newName) return true;

        var encounters = 0;
        for (var i = 0; i < this.all.length; i++) {
            if (this.all[i].data.name === newName)
                encounters++;

            if (encounters > 1)
                return false;
        }

        return true;
    };

    return new DropCache();
});
